import Image from "next/image";

export type IndustryBenefitsProps = {
    headline: string;
    benefitList: {
        icon: string;
        title: string;
        description: string;
    }[];
};
export function IndustryBenefits({ headline, benefitList }: IndustryBenefitsProps) {
    return (
        <>
            <div className="section_industry-benefits">
                <div className="padding-global">
                    <div className="container-large">
                        <div className="padding-top padding-xhuge">
                            <div className="max-width-large align-center">
                                <div className="text-align-center">
                                    <h2 className="text-[var(--primary--burgundy)] dark:text-[var(--primary--pink)]">
                                        {headline}
                                    </h2>
                                    <div className="padding-bottom padding-xlarge"></div>
                                </div>
                            </div>
                            <div className="features-list2_component">
                                <div role="list" className="features-list2_layout">
                                    {benefitList.map((item, idx) => (
                                        <div role="listitem" className="features-list2_item" key={idx}>
                                            <div className="features-list2_icon-wrapper">
                                                <Image src={item.icon} unoptimized width={32} height={32} alt="" className="icon-1x1-medium" />
                                            </div>
                                            <div className="padding-bottom padding-xsmall"></div>
                                            <div className="heading-xxsmall">{item.title}</div>
                                            <div className="padding-bottom padding-xxsmall"></div>
                                            <div className="text-size-regular text-gray-800 dark:text-gray-300">{item.description}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="py-7">
                {/* <CtaButtonsComponent ctas={ctas} /> */}
            </div>
        </>

    )
}
